export const ADMIN = "admin";
